import React from "react";

const ToursForm = ({ handleAddTour, handleFieldChange, tourFields }) => {

  return (
    <form className="hideFormLtTablet" onSubmit={handleAddTour}>
      <h3 className="form-heading">Add a tour</h3>

      <div>
      <label htmlFor="artist">Artist</label>
        <input 
          type="text"
          name="artist"
          id="artist"
          placeholder="eg. Frank Zappa"
          value={tourFields.artist}
          onChange={handleFieldChange}
        />
      </div>

      <div>
        <label htmlFor="name">Tour name</label>
        <input 
          type="text"
          name="name"
          id="name"
          placeholder="eg. 2021 Autumn Tour"
          value={tourFields.name}
          onChange={handleFieldChange}
        />
      </div>

      <button disabled={!tourFields.name || !tourFields.artist} className="form-button" type="submit">Add tour</button>
    </form>
  )

};

export default ToursForm;